import { observable, configure, action } from 'mobx';
import util from 'preact-util';
import LocalModel from './localModel';

configure({ enforceActions: 'always' });

const EMPTY = { counts: { going: 0, interested: 0, maybe: 0 }, people: [], mine: '' };

// Stevne RSVP («Skal / Interessert / Kanskje») on the terminliste, backend
// /api/nsfcompetitionrsvps/. byCompetition holds one summary per stevne id:
// counts, the visible responders (avatars) on this club site and my own status.
class NsfCompetitionRsvpStore extends LocalModel {
    constructor() {
        super('nsfCompetitionRsvp', {
            namePlural: 'nsfCompetitionRsvps',
            namePluralReal: 'nsfcompetitionrsvps',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: { url: '/api/nsfcompetitionrsvps/', params: {} },
                load: { url: '/api/nsfcompetitionrsvps/', params: {} },
                save: { url: '/api/nsfcompetitionrsvps/', params: {} },
                delete: { url: '/api/nsfcompetitionrsvps/', params: {} },
            },
        });
    }

    @observable nsfCompetitionRsvps = [];

    @observable nsfCompetitionRsvp = {};

    @observable byCompetition = {};

    summaryFor(id) {
        return (this.byCompetition && this.byCompetition[id]) || EMPTY;
    }

    hasResponse(id) {
        return !!this.summaryFor(id).mine;
    }

    @action
    async loadFor(ids = []) {
        const unique = [...new Set((ids || []).map(id => parseInt(id, 10)).filter(id => id > 0))];
        if (unique.length === 0) {
            return;
        }
        try {
            const response = await util.fetchApi('/api/nsfcompetitionrsvps/', { method: 'GET' }, { ids: unique.join(',') });
            if (response?.status === 200 && response.data) {
                this.updateKeyValue('byCompetition', { ...(this.byCompetition || {}), ...response.data });
            }
        } catch (err) {
            console.error('nsfCompetitionRsvp loadFor failed', err);
        }
    }

    /** Set my status; clicking the active status again clears it. */
    @action
    async setStatus(id, status) {
        const next = this.summaryFor(id).mine === status ? '' : status;
        try {
            const response = await util.fetchApi('/api/nsfcompetitionrsvps/', { method: 'POST' }, { nsfCompetitionId: id, status: next });
            if (response?.status === 200 || response?.status === 201) {
                await this.loadFor([id]);
            }
        } catch (err) {
            console.error('nsfCompetitionRsvp setStatus failed', err);
        }
    }
}

const store = new NsfCompetitionRsvpStore();
export { NsfCompetitionRsvpStore };
export default store;
